/**
 * NOTE: This map is test only and maintained by strings as keys. It should not be used anywhere outside the test.
 */
module.exports = {
	'toilet flow rate regulations (exceeds 1.28 GPM limit)': [
		{
			siteId: 82,
			alternateCta: '/ca-compliant-toilets/c133290'
		},
		{
			siteId: 4,
			alternateCta: '/toilets/c56?f62986=ca%20drought%20compliant'
		},
		{
			siteId: 84,
			alternateCta: '/toilets/c80033?f62998=ca%20drought%20compliant'
		}
	],
	'appliance efficiency regulations': [
		{
			siteId: 82,
			alternateCta: '/shop-all-wine-coolers/c133891?f67440=compressor'
		}
	],
	'urinal flow rate regulations (exceeds 0.125 GPF limit)': [
		{
			siteId: 82,
			alternateCta: '/ca-compliant-urinals-flushometers/c133688'
		},
		{
			siteId: 4,
			alternateCta: '/urinal-flush-valves/c43943?f62985=ca%20drought%20compliant'
		},
		{
			siteId: 84,
			alternateCta: '/urinals/c84143?f62999=ca%20drought%20compliant'
		}
	],
	'faucet flow rate regulations (exceeds 1.2 GPM limit)': [
		{
			siteId: 82,
			alternateCta: '/ca-compliant-bathroom-faucets/c133274'
		},
		{
			siteId: 4,
			alternateCta: '/bathroom-sink-faucets/c64?f62984=ca%20drought%20compliant'
		},
		{
			siteId: 84,
			alternateCta: '/bathroom-sink-faucets/c80009?f62999=ca%20drought%20compliant'
		}
	],
	'faucet flow rate regulations (exceeds 1.8 GPM limit)': [
		{
			siteId: 82,
			alternateCta: '/ca-compliant-kitchen-faucets/c133291'
		},
		{
			siteId: 4,
			alternateCta: '/kitchen-faucets/c19?f62983=ca%20drought%20compliant'
		},
		{
			siteId: 84,
			alternateCta: '/kitchen-faucets/c80010?f62997=ca%20drought%20compliant'
		}
	],
	'shower head flow rate regulations (exceeds 1.8 GPM limit)': [
		{
			siteId: 82,
			alternateCta: '/ca-compliant-shower-faucets/c133683'
		},
		{
			siteId: 4,
			alternateCta: '/shower-faucets/c57?f62985=ca%20drought%20compliant'
		},
		{
			siteId: 84,
			alternateCta: '/shower-faucets/c80011?f62996=ca%20drought%20compliant'
		}
	],
	'faucet flow rate regulations (exceeds 0.5 GPM limit)': [
		{
			siteId: 82,
			alternateCta: '/ca-compliant-commercial-faucets/c133697'
		},
		{
			siteId: 4,
			alternateCta: '/commercial-bathroom-sink-faucet/c11009?f62984=ca%20drought%20compliant&f62990=up%20to%201%20gpm'
		},
		{
			siteId: 84,
			alternateCta: '/bathroom-sink-faucets/c80009?f21488=commercial&f62999=ca%20drought%20compliant'
		}
	]
};
